import React from 'react'

const Vipexp = () => {
  return (
    <section className="vip-exp">
        <div className="container-xl">
            <div className="row">
                <div className="col-12 text-center">
                    <div className="heading-area">
                        <h2> Treat your skin to the <span>VIP experience</span> it deserves with Diddy Baby Oil</h2>
                    </div>
                    <img loading="lazy" decoding="async" width="888" height="568" className="img-fluid" src="images/vip-exp.png" alt="VIP experience"/>
                </div>
            </div>
        </div>
    </section>
  )
}

export default Vipexp